<script lang="ts">
	import ButtonBoxPrimary from './ButtonBoxPrimary.svelte';
	import { t } from 'svelte-i18n';
	import type { OperationModel } from '@app/models/api/OperationModel';
	import type { ButtonBoxType } from '../types';
	import { signInUpModalStore } from '@app/stores/signInUpModal';
	import { page } from '$app/stores';

	export let operation: OperationModel;
	export let props: ButtonBoxType = {};
	export let openModal: () => void;
</script>

{#if $page.data.user}
	<ButtonBoxPrimary props={{ label: $t('voteAction') }} on:click={() => openModal()} />
{:else}
	<ButtonBoxPrimary
		props={{ label: $t('connectAndVote') }}
		on:click={() => {
			signInUpModalStore.open();
		}}
	/>
{/if}
